module.exports = __webpack_public_path__ + "static/media/ss-math-344.7256a79b.png";